"use client";

import React, { useMemo } from "react";
import { Asset } from "@thenounproject/lingo-core";
import { useSelection } from "@contexts/SelectedItemsProvider";
import InspectorView from "../../../components/inspector/InspectorView";
import { InspectorSource } from "@constants/Inspector";

type Props = {
  assets: Asset[];
  canEdit: boolean;
  children: React.ReactNode;
};

/**
 * Bridges the asset library selection state to the InspectorView.
 * Subscribes to selection so the inspector updates reactively,
 * while children (the table) are passed as a prop and won't re-render.
 */
const AssetLibraryInspectorView: React.FC<Props> = ({ assets, canEdit, children }) => {
  const selection = useSelection("assetLibrary");

  const inspectables = useMemo(() => {
    const selected = assets?.filter(a => selection.includes(a?.uuid)) ?? [];
    return selected.map(asset => ({ asset }));
  }, [assets, selection]);

  return (
    <InspectorView inspectables={inspectables} canEdit={canEdit} source={InspectorSource.library}>
      {children}
    </InspectorView>
  );
};

export default AssetLibraryInspectorView;
